// A recipients file and the identity file `age-keygen` writes are the same shape — a key to a line, blanks and `#`
// comments allowed — and `/cryptography` reads one to seal or open a file where `/keygen` reads one to write the
// recipients file `age-keygen -y` answers with, so the reading is here and neither of them owns it.
export function keyLines(text: string): string[] {
  return text.split("\n").map((line) => line.trim()).filter((line) => line !== "" && !line.startsWith("#"));
}

// What `age-keygen -y` answers with: the recipient every identity in a file hands out, in the order they were
// written. typage is imported dynamically here for the reason both pages already import it that way.
export async function identityRecipients(text: string): Promise<string[]> {
  const { identityToRecipient } = await import("age-encryption");
  return Promise.all(
    keyLines(text).map(async (line) => {
      try {
        return await identityToRecipient(line);
      } catch {
        throw new Error(`That is not an age identity: ${shortened(line)}`);
      }
    }),
  );
}

// typage answers a key it cannot read with "invalid identity", which is true and is not a sentence. The line it came
// from is what a box holding several of them has to say back, and a post-quantum key is cut short in it: two thousand
// characters of encapsulation key under an output box says less than the twenty-four it opens with.
export function shortened(line: string): string {
  return line.length > SHOWN ? `${line.slice(0, SHOWN)}…` : line;
}

const SHOWN = 24;
